import { Route } from 'vue-router';
import { useHBLStore } from '@/store/modules/house-bl/useHBLStore';
import { MBL_VIEW_TABS } from '@/constants/master-bl';
import { getMblShipmentNumberFromHbl } from '@/modules/house-bl';
import { HblViewTabs } from '@/types/hbl/hbl.enums';
import { BreadCrumb } from '@/types/common/breadcrumb.types';
import { HblEntity } from '@/types/hbl/hbl.entity';

const breadCrumbLabel: Record<HblViewTabs, string> = {
  [HblViewTabs.Details]: '',
  [HblViewTabs.Charges]: 'Charges',
  [HblViewTabs.Milestones]: 'Milestones',
  [HblViewTabs.Attachments]: 'Attachments',
  [HblViewTabs.ItApplication]: 'In Bond',
  [HblViewTabs.Print]: 'Print',
};
const getBreadCrumbLabel = (tab: HblViewTabs): string => {
  return breadCrumbLabel[tab] || '';
};
const getFromBreadCrumb = (breadCrumb: BreadCrumb): BreadCrumb => {
  return breadCrumb || { text: `MBL list view`, to: { name: 'ManifestImports' } };
};
const generateHblViewBreadCrumbs = (
  hbl: HblEntity,
  tab: HblViewTabs,
  fromBreadCrumb: BreadCrumb
) => {
  const resultBreadcrumbs: BreadCrumb[] = [
    // { text: `MBL list view`, to: { name: 'ManifestImports' } },
    fromBreadCrumb,
    {
      text: `MBL ${getMblShipmentNumberFromHbl(hbl.shipmentNumber)}`,
      to: {
        name: 'MasterBL',
        params: {
          id: hbl.mblId,
        },
      },
    },
    {
      text: 'HBL View List',
      to: {
        name: 'MasterBL',
        params: {
          id: hbl.mblId,
        },
        query: {
          tab: MBL_VIEW_TABS.hblList,
        },
      },
    },
    {
      text: `HBL ${hbl.shipmentNumber}`,
      to: { name: 'HouseBL', query: { tab: HblViewTabs.Details } },
    },
  ];
  if (tab !== HblViewTabs.Details && tab) {
    resultBreadcrumbs.push({ text: getBreadCrumbLabel(tab) });
  }

  return resultBreadcrumbs;
};

export const getHblViewBreadCrumbs = (route: Route): BreadCrumb[] => {
  const hblStore = useHBLStore();

  if (!hblStore.hbl) return [];

  const query = route.query.tab as HblViewTabs;
  const fromBreadCrumb = route.meta!.fromBreadCrumb as BreadCrumb;
  return generateHblViewBreadCrumbs(hblStore.hbl, query, getFromBreadCrumb(fromBreadCrumb));
};
